import { createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-41f22371")

_pushScopeId("data-v-41f22371")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("プロンプト設定")
const _hoisted_2 = { class: "container mx-auto px-10 py-12" }
const _hoisted_3 = { class: "flex-1 mb-2" }
const _hoisted_4 = { class: "flex  justify-between" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", {
  for: "title",
  class: "leading-7 text-sm text-gray-600"
}, " タイトル ", -1)
const _hoisted_6 = { class: "leading-7 text-sm text-gray-600" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" このプロンプトに切替える ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 現在、このプロンプトを利用しています ")
const _hoisted_10 = { class: "w-full mx-auto mb-12" }
const _hoisted_11 = {
  for: "message",
  class: "leading-7 text-sm text-gray-600"
}
const _hoisted_12 = {
  key: 0,
  class: "leading-7 text-sm text-red-500"
}
const _hoisted_13 = { class: "leading-7 text-sm text-gray-600 flex" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" このプロンプトに切替える ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 現在、このプロンプトを利用しています ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" + プロンプトを複製する ")
const _hoisted_17 = { class: "flex" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 保存 ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 削除 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_m_button = _resolveComponent("m-button")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, { onClose: _ctx.close }, {
    title: _withId(() => [
      _hoisted_1
    ]),
    body: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.prompts, (prompt, index) => {
            return (_openBlock(), _createBlock("div", {
              key: index,
              class: "mb-5"
            }, [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode("p", _hoisted_6, " 更新日時: " + _toDisplayString(_ctx.convertDatetime(prompt.data.updatedAt)), 1)
                ]),
                _createVNode("div", _hoisted_7, [
                  _createVNode("button", {
                    class: ["px-2 cursor-pointer transition duration-300 text-center rounded border bg-primary-100 focus:border-primary-500 text-gray-700", { active: _ctx.activeIndex === index }],
                    onClick: ($event: any) => (_ctx.toggleAccordion(index))
                  }, _toDisplayString(_ctx.activeIndex === index ? " ー " : " ＋ "), 11, ["onClick"]),
                  _withDirectives(_createVNode("input", {
                    "onUpdate:modelValue": ($event: any) => (prompt.data.name = $event),
                    type: "text",
                    name: "title",
                    placeholder: "タイトルを入力",
                    class: "w-full bg-primary-100 rounded border focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-300"
                  }, null, 8, ["onUpdate:modelValue"]), [
                    [_vModelText, prompt.data.name]
                  ])
                ])
              ]),
              _withDirectives(_createVNode("div", null, [
                (_ctx.currentPromptId != prompt?.ref.id)
                  ? (_openBlock(), _createBlock(_component_m_button, {
                      key: 0,
                      color: "secondary-500",
                      "hover-color": "secondary-600",
                      disabled: !_ctx.validPrompt,
                      class: "mr-4",
                      onClick: ($event: any) => (_ctx.selectPrompt(prompt))
                    }, {
                      default: _withId(() => [
                        _hoisted_8
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.currentPromptId === prompt?.ref.id)
                  ? (_openBlock(), _createBlock(_component_m_button, {
                      key: 1,
                      color: "secondary-600",
                      "hover-color": "secondary-600",
                      disabled: !_ctx.validPrompt,
                      class: "mr-4",
                      onClick: ($event: any) => (_ctx.selectPrompt(prompt))
                    }, {
                      default: _withId(() => [
                        _hoisted_9
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"]))
                  : _createCommentVNode("", true)
              ], 512), [
                [_vShow, _ctx.activeIndex != index]
              ]),
              _createVNode("div", {
                class: "accordion-content",
                style: {
                maxHeight: _ctx.activeIndex === index ? `500px` : '0'
              }
              }, [
                _createVNode("div", _hoisted_10, [
                  _createVNode("label", _hoisted_11, [
                    _createTextVNode(" プロンプト 現在の文字数: " + _toDisplayString(prompt.data.text.length) + " ※最大1000文字 ", 1),
                    (prompt.data.text.length > 1000)
                      ? (_openBlock(), _createBlock("span", _hoisted_12, " ※ 最大文字数を超えています "))
                      : _createCommentVNode("", true)
                  ]),
                  _withDirectives(_createVNode("textarea", {
                    "onUpdate:modelValue": ($event: any) => (prompt.data.text = $event),
                    name: "message",
                    placeholder: "メッセージを入力",
                    rows: "7",
                    class: "w-full bg-primary-100 rounded-md border border-primary-100 focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-300"
                  }, null, 8, ["onUpdate:modelValue"]), [
                    [_vModelText, prompt.data.text]
                  ]),
                  _createVNode("div", _hoisted_13, [
                    _createVNode("div", null, [
                      (_ctx.currentPromptId != prompt?.ref.id)
                        ? (_openBlock(), _createBlock(_component_m_button, {
                            key: 0,
                            color: "secondary-500",
                            "hover-color": "secondary-600",
                            disabled: !_ctx.validPrompt,
                            class: "mr-4",
                            onClick: ($event: any) => (_ctx.selectPrompt(prompt))
                          }, {
                            default: _withId(() => [
                              _hoisted_14
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.currentPromptId === prompt?.ref.id)
                        ? (_openBlock(), _createBlock(_component_m_button, {
                            key: 1,
                            color: "secondary-600",
                            "hover-color": "secondary-600",
                            disabled: !_ctx.validPrompt,
                            class: "mr-4",
                            onClick: ($event: any) => (_ctx.selectPrompt(prompt))
                          }, {
                            default: _withId(() => [
                              _hoisted_15
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_m_button, {
                      color: "primary-500",
                      "hover-color": "primary-600",
                      disabled: !_ctx.validPrompt,
                      class: "mb-1 mr-auto",
                      onClick: ($event: any) => (_ctx.replicatePrompt(prompt))
                    }, {
                      default: _withId(() => [
                        _hoisted_16
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"]),
                    _createVNode("div", _hoisted_17, [
                      _createVNode(_component_m_button, {
                        color: "primary-500",
                        "hover-color": "primary-600",
                        disabled: !_ctx.validPrompt,
                        class: "mb-1 px-20",
                        onClick: ($event: any) => (_ctx.updatePrompt(prompt))
                      }, {
                        default: _withId(() => [
                          _hoisted_18
                        ]),
                        _: 2
                      }, 1032, ["disabled", "onClick"]),
                      _createVNode(_component_m_button, {
                        color: "sub-500",
                        "hover-color": "sub-600",
                        disabled: !_ctx.validPrompt,
                        class: "mb-1 ml-4",
                        onClick: ($event: any) => (_ctx.deletePrompt(prompt))
                      }, {
                        default: _withId(() => [
                          _hoisted_19
                        ]),
                        _: 2
                      }, 1032, ["disabled", "onClick"])
                    ])
                  ])
                ])
              ], 4)
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
})